export default __webpack_public_path__ + "static/media/pokemon_dragon.5c51c1bd.png";